import styled, {css} from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../framework/helpers/BreakpointHelper/BreakpointHelper";
import React from "react";
import {H2} from "BaseComponents/Text";
import {PrimaryButton} from "BaseComponents/Button";
import {footerTextClass} from "Helpers/ColorHelper";
import {useGlobal} from "reactn";

export const FooterColumn = ({Headline, Links, text, useThree}) => {
    const [theme] = useGlobal("theme");
    return (
        <Grid useThree={useThree}>
            {Headline && <H2 fontWeight="700">{Headline}</H2>}
            <Info className="footer__grid__info footerInfo_section">
                {Links != undefined &&
                    Links.map((link, i) => (
                        <a
                            target={link?.Target ?? '_self'}
                            key={`footer-column-link-${i}`}
                            className={`element-link--footer ${footerTextClass(
                                theme.colors.footerGradient
                            )}`}
                            href={link.Url}
                        >
              <span className="element-link--footer--standard">
                {link.Name}
              </span>
                        </a>
                    ))}
            </Info>
        </Grid>
    );
};
export const Department = (dep) => {
    const {DepartmentName, PhoneNumber, IsBold} = dep;
    return (
        <DepartmentStyle isBold={IsBold}>
            <span>{DepartmentName}</span>
            <a href={`tel:${PhoneNumber}`}>{PhoneNumber}</a>
        </DepartmentStyle>
    );
};

export const Footer = styled.footer`
    background: ${({theme}) => theme.footerGradient};
    padding: 0 3rem;

    ${media.lessThan(breakpoints.ipad)`
    padding: 1rem 1rem;

    `}

    ${media.lessThan(breakpoints.mobile)`
		padding: 0;
	`}
`;
export const H3 = styled.h3`
    font-size: 16px;
    line-height: unset;
    margin: 0;
`;
export const FooterTop = styled.div`
    flex-wrap: wrap;
    display: flex;
    row-gap: ${({rowGap}) => (rowGap ? rowGap : "4rem")};

    ${media.lessThan(breakpoints.ipad)`
  row-gap: ${({smallRowGap}) => (smallRowGap ? smallRowGap : "2rem")};
  `}
`;
export const FooterBottom = styled.div`
    justify-content: space-between;
    margin-top: ${({marginTop}) => (marginTop ? marginTop : "70px")};
    display: flex;
    flex-direction: ${({flexDirection}) => (flexDirection ? flexDirection : "column")};

    ${media.lessThan(breakpoints.mobile)`
	 flex-direction: column;
`}
    ${media.lessThan(breakpoints.ipad)`
	margin-top: 20px;
`}
    .logo-link {
        &.margin-top {
            margin-top: 1rem;
        }
    }

    img {
        margin-bottom: 15px;
        max-width: 192px;
    }
`;

export const FooterBottomReportBlock = styled.div`
    display: flex;
    align-items: center;

    ${media.lessThan(breakpoints.mobile)`
	 margin-top: 80px;
	 align-self: flex-end;
`}
    i {
        font-size: 24px;
    }

    a {
        display: flex;
        align-items: center;
        gap: 12px;
        font-weight: 500;

        span {
            &:hover {
                border-bottom: 2px solid #ffffff;
            }
        }
    }
`
export const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${({alignItems}) => (alignItems ? alignItems : "center")};
    margin: ${({margin}) => (margin ? margin : " 10px 0")};
`;
export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: ${({theme}) => theme.grid.outer};
    margin: 0 auto;
    padding: 5rem 1rem;

    ${media.lessThan(breakpoints.ipad)`
        padding-left: 1rem;
        `}
    ${media.lessThan(breakpoints.mobile)`
        padding: 3rem 1rem;
        `}
    p,
    h1,
    a,
    h2,
    h3 {
        color: ${({theme}) => theme.colors.footerSpanColor};
    }

    h2 {
        font-size: 24px;
    }
`;

export const Info = styled.div`
    padding: 0.5rem 0;
    display: flex;
    flex-direction: column;

    .element-link--footer {
        display: flex;
    }

    div {
        color: ${({theme}) => theme.colors.footerSpanColor};
    }

    p {
        margin: 1px;
    }

    a {
        width: fit-content;

        &:hover {
            span {
                border-color: ${({theme}) => theme.colors.footerSpanColor};
            }
        }

        span {
            border-bottom: 2px solid transparent;
            transition: 0.2s ease;
            color: ${({theme}) => theme.colors.footerSpanColor};
        }
    }

    i:before {
        margin-right: 8px;
        ${({margin}) => `margin-left: ${margin};`}
        font-size: 14px;
        color: ${({theme}) => theme.colors.footerSpanColor};
    }
`;
const DepartmentStyle = styled.li`
    content: none;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    min-width: 200px;

    line-height: 23px;
    margin-bottom: 5px;

    a {
        border-bottom: 1px solid transparent;
        transition: 0.2s ease;

        &:hover {
            transition: 0.2s ease;

            border-color: ${({theme}) => theme.colors.footerSpanColor};
        }

        span {
            font-weight: normal;
            float: right;
            margin-left: 19px;
        }
    }

    justify-content: space-between;

    span {
        color: ${({theme}) => theme.colors.footerSpanColor};
        font-weight: ${({isBold}) => (isBold ? "bold" : "normal")};
    }
`;

export const Grid = styled.div`
    flex-wrap: wrap;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 0 4rem 0 0;
    min-width: 200px;

    ${({useThree}) =>
            useThree &&
            css`
                flex-basis: 33%;
                flex-grow: 0;
            `}
    h2 {
        margin-bottom: 10px;
    }

    ${media.lessThan(breakpoints.ipad)`
			flex-basis: 50%;
            flex-grow: 1;
			padding: 1rem 3rem 1rem 0;
            `}
    &:last-of-type {
        padding-right: 0;
    }
`;
